import { render } from "./navheader.vue?vue&type=template&id=a881cfcc"
import script from "./navheader.vue?vue&type=script&lang=js"
export * from "./navheader.vue?vue&type=script&lang=js"

import "./navheader.vue?vue&type=style&index=0&id=a881cfcc&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__